module.exports = __webpack_public_path__ + "img/404.28ce1ab6.jpg";